<template>
  <v-container
    class="d-flex justify-end mt-2"
    style="font-size:80%;"
  >
    <a href="https://www.stretchlimoberlin.de/impressum.php" target="_blank" class="mx-2">Impressum</a>
    |
    <a href="https://www.stretchlimoberlin.de/datenschutz.php" target="_blank" class="mx-2">Datenschutz</a>
  </v-container>
</template>

<script>

export default {
  name: 'Impressum',
  components: {
  },
  props: {
  },
  data: () => ({
  }),
  watch: {
  },
  computed: {
  },
  methods: {
  },
  created() {
  },
};
</script>
